module.exports = __webpack_public_path__ + "gw.svg?f0742332f72950dc2c88c2793ffe423f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/gw.svg
// module id = 1139
// module chunks = 0